module.exports = __webpack_public_path__ + "img/HA2508-01.34851215.jpg";